import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { useTextEnableLandlineStepsContext } from 'pages/settings/pages/numbers/pages/TextEnableLandline/context/useTextEnableLandlineStepsContext'
import { EnterAddressCommon } from 'pages/settings/ui/EnterAddressCommon'

export const EnterAddress = observer(() => {
  const { enterNumberStore, enterAddressStore } = useTextEnableLandlineStepsContext()
  const { phone } = enterNumberStore

  useEffect(() => {
    enterAddressStore.init()
  }, [])

  return <EnterAddressCommon phone={phone} enterAddressStore={enterAddressStore} />
})
